export let MOSTRAR_TODO : string = "-1" 